import { string, object, SchemaOf } from 'yup'
import { unMaskInputs } from '../../utils'
import cpfIsValid from '../../utils/validators/cpfIsValid'

export interface IAuthAccessSchema {
    name: string
    cpf: string
    email: string
    password: string
    passwordConf: string
}

const requestAccessSchema: SchemaOf<IAuthAccessSchema> = object().shape({
    name: string().required('Preencha o campo com seu nome.'),
    cpf: string()
        .required('Preencha o campo com seu CPF.')
        .min(11, 'O campo CPF está incompleto')
        .test('test-invalid-cpf', 'CPF Inválido.', (cpf) => {
            if (!cpf) return false
            return cpfIsValid(unMaskInputs(cpf))
        }),
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
    password: string().required('Preencha o campo com sua senha.'),
    passwordConf: string().required('Confirme sua nova senha.'),
})

export default requestAccessSchema
